"use strict";

var _interopRequireDefault = require("/www/wwwroot/deduct_node/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/www/wwwroot/deduct_node/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.split");
var _request = _interopRequireDefault(require("@/utils/request"));
// 权限认证相关的插件,简易版的认证鉴权插件

var UserService = {
  initialize: function initialize() {
    console.log('init');
  },
  data: {
    shopList: undefined,
    shop: undefined
  },
  setCookie: function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
  },
  getCookie: function getCookie(name) {
    var cookieName = name + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
      var cookie = cookieArray[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
    return '';
  },
  deleteCookie: function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  },
  updateShop: function updateShop(shop) {
    this.setCookie('currentShop', shop);
    this.data.shop = shop;
  },
  getShopList: function () {
    var _getShopList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(this.data.shopList === undefined)) {
              _context.next = 6;
              break;
            }
            this.data.shop = this.getCookie('currentShop');
            _context.next = 4;
            return (0, _request.default)({
              url: "/Shop/",
              method: 'get',
              params: {
                page: 1,
                page_size: 50
              }
            });
          case 4:
            response = _context.sent;
            if (response.data) {
              this.data.shopList = response.data.results.map(function (item) {
                return {
                  'label': item['product_name'] || item['company_name'],
                  'value': item['id']
                };
              });
              if (response.data.length > 0 && this.data.shop === undefined) {
                this.data.shop = response.data[0]['value'];
              }
            }
          case 6:
            return _context.abrupt("return", this.data.shopList);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function getShopList() {
      return _getShopList.apply(this, arguments);
    }
    return getShopList;
  }()
};
var UserPlugin = {
  install: function install(Vue) {
    Vue.prototype.$user = UserService;
  }
};
var _default = exports.default = UserPlugin;